import { render, staticRenderFns } from "./JournalCell.vue?vue&type=template&id=017ff519&"
import script from "./JournalCell.vue?vue&type=script&lang=js&"
export * from "./JournalCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports